import { useState, useRef } from "react";
import { TextField, Button, Grid, Box, Typography } from "@mui/material";
import { db } from "../../firebaseConfig"; 
import { collection, addDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import Barcode from "react-barcode";
import { toPng } from "html-to-image";

export default function InventoryForm() {
  const barcodeRef = useRef();

  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    cantidad: "",
    precioVenta: "",
    precioProveedor: "",
    ubicacion: "",
  });

  const [codigoGenerado, setCodigoGenerado] = useState(uuidv4().slice(0, 8)); // Código más corto

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDownloadBarcode = async () => {
    if (barcodeRef.current) {
      const dataUrl = await toPng(barcodeRef.current);
      const link = document.createElement('a');
      link.download = `barcode-${codigoGenerado}.png`;
      link.href = dataUrl;
      link.click();
    }
  };

  const handlePrintBarcode = () => {
    const printWindow = window.open('', '_blank');
    const barcodeHTML = barcodeRef.current.outerHTML;
    printWindow.document.write(`
      <html>
        <head><title>Imprimir Código de Barras</title></head>
        <body onload="window.print(); window.close();">${barcodeHTML}</body>
      </html>
    `);
    printWindow.document.close();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Datos a guardar
      const data = {
        ...formData,
        codigoBarras: codigoGenerado,
        cantidad: parseInt(formData.cantidad) || 0
      };

      await addDoc(collection(db, "refacciones"), data);

      // Limpiar formulario
      setFormData({
        nombre: "",
        descripcion: "",
        cantidad: "",
        precioVenta: "",
        precioProveedor: "",
        ubicacion: "",
      });
      setCodigoGenerado(uuidv4().slice(0, 8)); // Nuevo código para siguiente producto

      alert("Refacción guardada exitosamente.");
    } catch (error) {
      console.error("Error al guardar la refacción:", error);
      alert("Hubo un error al guardar la refacción.");
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Nombre" name="nombre" value={formData.nombre} onChange={handleChange} required />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Descripción" name="descripcion" value={formData.descripcion} onChange={handleChange} required />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Cantidad" name="cantidad" type="number" value={formData.cantidad} onChange={handleChange} required />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Precio Venta" name="precioVenta" type="number" value={formData.precioVenta} onChange={handleChange} required />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Precio Proveedor (opcional)" name="precioProveedor" value={formData.precioProveedor} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth label="Ubicación (opcional)" name="ubicacion" value={formData.ubicacion} onChange={handleChange} />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1">Código de barras:</Typography>
          <div ref={barcodeRef}>
            <Barcode value={codigoGenerado} width={1.5} height={50} fontSize={14} />
          </div>
          <Button onClick={handleDownloadBarcode} sx={{ mt: 1, mr: 1 }}>Descargar</Button>
          <Button onClick={handlePrintBarcode} sx={{ mt: 1 }}>Imprimir</Button>
        </Grid>
        
        <Grid item xs={12}>
          <Button variant="contained" type="submit">Guardar Refacción</Button>
        </Grid>
      </Grid>
    </Box>
  );
}
